export const userConstants = {
  GET_HOME_DATA_REQUEST: 'GET_HOME_DATA_REQUEST',
  GET_HOME_DATA_SUCCESS: 'GET_HOME_DATA_SUCCESS',
  GET_HOME_DATA_ERROR: 'GET_HOME_DATA_ERROR',

  GET_CONCERTS_DATA_REQUEST: 'GET_CONCERTS_DATA_REQUEST',
  GET_CONCERTS_DATA_SUCCESS: 'GET_CONCERTS_DATA_SUCCESS',
  GET_CONCERTS_DATA_ERROR: 'GET_CONCERTS_DATA_ERROR',

  GET_PAST_CONCERTS_DATA_REQUEST: 'GET_PAST_CONCERTS_DATA_REQUEST',
  GET_PAST_CONCERTS_DATA_SUCCESS: 'GET_PAST_CONCERTS_DATA_SUCCESS',
  GET_PAST_CONCERTS_DATA_ERROR: 'GET_PAST_CONCERTS_DATA_ERROR',

  GET_CONCERT_DATA_REQUEST: 'GET_CONCERT_DATA_REQUEST',
  GET_CONCERT_DATA_SUCCESS: 'GET_CONCERT_DATA_SUCCESS',
  GET_CONCERT_DATA_ERROR: 'GET_CONCERT_DATA_ERROR',

  GET_ARTISTS_DATA_REQUEST: 'GET_ARTISTS_DATA_REQUEST',
  GET_ARTISTS_DATA_SUCCESS: 'GET_ARTISTS_DATA_SUCCESS',
  GET_ARTISTS_DATA_ERROR: 'GET_ARTISTS_DATA_ERROR',

  GET_FAQ_DATA_REQUEST: 'GET_FAQ_DATA_REQUEST',
  GET_FAQ_DATA_SUCCESS: 'GET_FAQ_DATA_SUCCESS',
  GET_FAQ_DATA_ERROR: 'GET_FAQ_DATA_ERROR',

  GET_USEFULCONTACTS_DATA_REQUEST: 'GET_USEFULCONTACTS_DATA_REQUEST',
  GET_USEFULCONTACTS_DATA_SUCCESS: 'GET_USEFULCONTACTS_DATA_SUCCESS',
  GET_USEFULCONTACTS_DATA_ERROR: 'GET_USEFULCONTACTS_DATA_ERROR',

  GET_SPONSORS_DATA_REQUEST: 'GET_SPONSORS_DATA_REQUEST',
  GET_SPONSORS_DATA_SUCCESS: 'GET_SPONSORS_DATA_SUCCESS',
  GET_SPONSORS_DATA_ERROR: 'GET_SPONSORS_DATA_ERROR',

  GET_CONTACTS_DATA_REQUEST: 'GET_CONTACTS_DATA_REQUEST',
  GET_CONTACTS_DATA_SUCCESS: 'GET_CONTACTS_DATA_SUCCESS',
  GET_CONTACTS_DATA_ERROR: 'GET_CONTACTS_DATA_ERROR',

  GET_NEWS_LISTING_DATA_REQUEST: 'GET_NEWS_LISTING_DATA_REQUEST',
  GET_NEWS_LISTING_DATA_SUCCESS: 'GET_NEWS_LISTING_DATA_SUCCESS',
  GET_NEWS_LISTING_DATA_ERROR: 'GET_NEWS_LISTING_DATA_ERROR',

  GET_NEWS_DATA_REQUEST: 'GET_NEWS_DATA_REQUEST',
  GET_NEWS_DATA_SUCCESS: 'GET_NEWS_DATA_SUCCESS',
  GET_NEWS_DATA_ERROR: 'GET_NEWS_DATA_ERROR',

  GET_PRESS_DATA_REQUEST: 'GET_PRESS_DATA_REQUEST',
  GET_PRESS_DATA_SUCCESS: 'GET_PRESS_DATA_SUCCESS',
  GET_PRESS_DATA_ERROR: 'GET_PRESS_DATA_ERROR',

  GET_PRESS_INNER_DATA_REQUEST: 'GET_PRESS_INNER_DATA_REQUEST',
  GET_PRESS_INNER_DATA_SUCCESS: 'GET_PRESS_INNER_DATA_SUCCESS',
  GET_PRESS_INNER_DATA_ERROR: 'GET_PRESS_INNER_DATA_ERROR',

  GET_ABOUT_DATA_REQUEST: 'GET_ABOUT_DATA_REQUEST',
  GET_ABOUT_DATA_SUCCESS: 'GET_ABOUT_DATA_SUCCESS',
  GET_ABOUT_DATA_ERROR: 'GET_ABOUT_DATA_ERROR',

  GET_DONATION_DATA_REQUEST: 'GET_DONATION_DATA_REQUEST',
  GET_DONATION_DATA_SUCCESS: 'GET_DONATION_DATA_SUCCESS',
  GET_DONATION_DATA_ERROR: 'GET_DONATION_DATA_ERROR',

  GET_PRESSFORM_DATA_REQUEST: 'GET_PRESSFORM_DATA_REQUEST',
  GET_PRESSFORM_DATA_SUCCESS: 'GET_PRESSFORM_DATA_SUCCESS',
  GET_PRESSFORM_DATA_ERROR: 'GET_PRESSFORM_DATA_ERROR',

  GET_SEARCH_RESULTS_REQUEST: 'GET_SEARCH_RESULTS_REQUEST',
  GET_SEARCH_RESULTS_SUCCESS: 'GET_SEARCH_RESULTS_SUCCESS',
  GET_SEARCH_RESULTS_ERROR: 'GET_SEARCH_RESULTS_ERROR',

  GET_SETTINGS_DATA_REQUEST: 'GET_SETTINGS_DATA_REQUEST',
  GET_SETTINGS_DATA_SUCCESS: 'GET_SETTINGS_DATA_SUCCESS',
  GET_SETTINGS_DATA_ERROR: 'GET_SETTINGS_DATA_ERROR',

  GET_META_DATA_REQUEST: 'GET_META_DATA_REQUEST',
  GET_META_DATA_SUCCESS: 'GET_META_DATA_SUCCESS',
  GET_META_DATA_ERROR: 'GET_META_DATA_ERROR',

};
